<template>
  <div class="fl-sym-px-4">
    <div class="fl-sym-mt-5 xs:fl-sym-mt-8 fl-sym-text-primary fl-sym-text-xxs">FORGOT PASSWORD</div>
    <div
      class="fl-sym-text-black fl-sym-text-5xl fl-sym-leading-tight fl-sym-font-semibold fl-sym-mb-2"
    >What's Your Email?</div>
    <div
      class="fl-sym-text-intermediate fl-sym-text-lg"
    >Enter your email below to receive your password reset instructions.</div>

    <div
      class="box rounded-sm fl-sym-p-2 fl-sym-mt-20 fl-sym-text-center"
    >A link has been sent to:<br> {{user.email}}</div>

    <div class="fl-sym-mt-8 xs:fl-sym-mt-10 fl-sym-mb-2">
      <button
        type="submit"
        @click="login"
        class="fl-sym-bg-primary fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm"
      >Login</button>
    </div>
    <div class="fl-sym-flex fl-sym-justify-center fl-sym-text-sm">
      <div class="fl-sym-text-primary hover:fl-sym-text-opacity-75">
        <router-link class="link" :to="{ name: 'register',}">Back</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
    login() {
      this.$router.push({ name: process.env.VUE_APP_AUTH_LOGIN });
    },
  },
};
</script>
<style>
.error {
  top: 460px;
  left: 20px;
  width: 366px;
  height: 16px;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font: "SFProDisplay-Regular";
  font-size: 16px;
  color: #ff3a19;
}

.box {
  border: 2px solid #00c8e3;
  border-radius: 10px;
  word-break: break-word;
  width: 280px;
  margin: 5rem auto auto auto;
}

@media screen and (max-width: 420px) {
  .box {
    width: 90%;
  }
}


</style>